// Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.
export default function getLayoutRect(element) {
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
// module id = 199
// module chunks = 25